// extracted by mini-css-extract-plugin
export default {"imageLink":"_3RcA-bx","image":"_1XvgPXE","text":"_1CixOZ3"};